import LoginForm from '../../components/LoginForm/LoginForm';

const LoginPage = () => {
  return (
    <div>
      <h2>Login</h2>
      <LoginForm />
    </div>
  );
};

export default LoginPage;
